import { Url, URLS } from '@wix/da-url';
import { MainNavigationItem } from './types';
import { PapiNetworkbar } from '@wix/da-papi-types';

const backendPageToReadableKeyMap = {
  dyw: 'watch',
  dd: 'dailyDeviations',
  rfy: 'home',
};

function findNewContentFor(
  key: string,
  mainNavNewContent?: PapiNetworkbar['mainNavNewContent']
) {
  return mainNavNewContent?.find(
    ({ page }) => (backendPageToReadableKeyMap[page] ?? page) === key
  );
}

export function getMainNavigationItems() {
  const defaults: MainNavigationItem[] = [
    {
      key: 'home',
      url: Url.browseHomeLink(),
    },
    {
      key: 'watch',
      url: Url.browseDeviantsYouWatchLink(),
      restrictLoggedIn: true,
      pageType: 'watch',
    },
    {
      key: 'shop',
      url: Url.shopLink(),
      desktopOrMobileOnly: 'mobile',
    },
    {
      key: 'dailyDeviations',
      url: Url.browseDailyDeviationsLink(),
      restrictLoggedIn: true,
      pageType: 'daily-deviations',
    },
    {
      key: 'dailyChallenges',
      url: Url.dailyChallengesLink(),
      pageType: 'tag',
    },
    {
      // two versions of this link for logged-out and logged-in viewers
      // since restrictLoggedIn and anonOnly are opposite values there shouldn't be key collision
      key: 'dreamupAnon',
      url: Url.dreamupLink(),
      anonOnly: true,
    },
    {
      key: 'dreamup',
      url: Url.dreamupLink(),
      restrictLoggedIn: true,
    },
    {
      key: 'videoCreator',
      url: Url.videoCreatorLink(),
      restrictLoggedIn: true,
      withFeature: 'video_creator',
    },
    {
      key: 'helpCenter',
      url: URLS.HELP,
      desktopOrMobileOnly: 'mobile',
      withFeature: 'privacy_policy_link',
    },
  ];

  return defaults;
}

export function generateMainNavigation(
  mainNavNewContent?: PapiNetworkbar['mainNavNewContent']
): MainNavigationItem[] {
  return getMainNavigationItems().map(menuItem => {
    const newContent = findNewContentFor(menuItem.key, mainNavNewContent);
    if (!newContent) {
      return menuItem;
    }

    return {
      ...menuItem,
      url: newContent.url,
      hasNewContent: true,
      turnOffWithThisPageview: newContent.turnOffWithThisPageview,
    };
  });
}
